import { BaseAPIError } from './BaseAPIError'

export class ApplicationAPIError extends BaseAPIError {}
